import PropTypes from 'prop-types';
import styles from './RoomSceneSwitcher.module.css';

export default function RoomSceneSwitcher({ rooms = [], activeRoomId, onRoomSelect }) {
    const handleRoomClick = (room) => {
        console.log('Room selected:', {
            area: room.area,
            specifier: room.specifier,
            sel: room.sel
        });
        
        if (onRoomSelect) {
            onRoomSelect(room);
        }
    };

    if (rooms.length === 0) {
        return null;
    }

    return (
        <div className={styles.container}>
            <h3 className={styles.title}>SWITCH TO:</h3>
            <div className={styles.divider}></div>
            
            <div className={styles.roomsList}>
                {rooms.map((room, index) => (
                    <div 
                        key={index}
                        className={`${styles.roomCard} ${activeRoomId === room.id ? styles.active : ''}`}
                        onClick={() => handleRoomClick(room)}
                    >
                        <div className={styles.imageWrapper}>
                            <img 
                                src={room.image} 
                                alt={room.area}
                                className={styles.roomImage}
                            />
                            <div className={styles.overlay}>
                                <svg className={styles.switchIcon} viewBox="0 0 20 15" fill="none">
                                    <path d="M19.894 9.749C19.965 9.82 20 9.903 20 10V12.143C20 12.24 19.965 12.323 19.894 12.394C19.823 12.465 19.74 12.5 19.643 12.5H4.286V14.643C4.286 14.74 4.25 14.823 4.18 14.894C4.109 14.965 4.025 15 3.929 15C3.839 15 3.75 14.963 3.661 14.888L0.1 11.317C0.033 11.25 0 11.168 0 11.071C0 10.967 0.033 10.882 0.1 10.815L3.672 7.243C3.739 7.176 3.824 7.143 3.929 7.143C4.025 7.143 4.109 7.178 4.18 7.249C4.25 7.32 4.286 7.403 4.286 7.5V9.643H19.643C19.74 9.643 19.823 9.678 19.894 9.749Z" fill="white"/>
                                    <path d="M19.9 3.672C19.967 3.739 20 3.824 20 3.929C20 4.033 19.967 4.118 19.9 4.185L16.328 7.757C16.261 7.824 16.176 7.857 16.071 7.857C15.975 7.857 15.891 7.822 15.82 7.751C15.75 7.68 15.714 7.597 15.714 7.5V5.357H0.357C0.26 5.357 0.177 5.322 0.106 5.251C0.035 5.18 0 5.097 0 5V2.857C0 2.76 0.035 2.677 0.106 2.606C0.177 2.535 0.26 2.5 0.357 2.5H15.714V0.357C15.714 0.253 15.748 0.167 15.815 0.1C15.882 0.033 15.967 0 16.071 0C16.161 0 16.25 0.037 16.339 0.112L19.9 3.672Z" fill="white"/>
                                </svg>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

RoomSceneSwitcher.propTypes = {
    rooms: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        area: PropTypes.string,
        image: PropTypes.string,
        specifier: PropTypes.string,
        sel: PropTypes.string
    })),
    activeRoomId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onRoomSelect: PropTypes.func
};
